export default __webpack_public_path__ + "static/media/249a7d8ca5562463eb74332b3047159e1578057308334.1fbefda2.webp";